import { createQueryKeys } from '@lukemorales/query-key-factory';
import type { GuideEmoticonParams } from '@module/apis/client-side/guide/type';

export const guideQueryKeys = createQueryKeys('guide', {
  fetchGuideEmoticonList: (params: GuideEmoticonParams) => [params],
});
